import { ApiTranslation } from '../../api/entities/translation.entity';
import { RecordType, RecordTypeStructure } from '../../records/entities/metadata/metadata.entity';

export interface ApiRecordType {
    Active: boolean;
    Name: RecordType;
    Structure: RecordTypeStructure;
    Workflow: string | null;
    InformationPackage: RecordTypeInformationPackage;
    DeletionPolicy: string;
    PublicationPolicy: PublicationPolicy[];
    CanPublishOnCreate: boolean;
    AllowedChildren: RecordType[];
    Labels: ApiTranslation[];
}

export enum RecordTypeInformationPackage {
    Aip = 'Aip',
    Cip = 'Cip',
    Sip = 'Sip'
}

export enum PublicationPolicy {
    RequirePublishedParent = 'RequirePublishedParent',
    Cascade = 'Cascade'
}
